import { TextareaHTMLAttributes, forwardRef } from "react";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, error, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-bold text-gray-700 dark:text-slate-400 mb-2 ml-1">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          className={`w-full px-4 py-3 bg-gray-50 dark:bg-[#1b254b]/50 border border-gray-200 dark:border-white/10 rounded-xl 
                        focus:bg-white dark:focus:bg-[#0b1437] focus:ring-4 focus:ring-blue-500/10 dark:focus:ring-white/5 focus:border-blue-500 dark:focus:border-white/20 
                        outline-none transition-all duration-300 placeholder:text-gray-400 dark:placeholder:text-slate-600 text-gray-800 dark:text-slate-200 font-medium sm:text-sm resize-none
                        ${error ? "border-red-500 focus:border-red-500 focus:ring-red-500/10" : ""} 
                        ${className || ""}`}
          {...props}
        />
        {error && (
          <p className="mt-1.5 text-xs font-semibold text-red-500 flex items-center gap-1.5 ml-1">
            {error}
          </p>
        )}
      </div>
    );
  },
);

Textarea.displayName = "Textarea";
